import type { FetchError } from "app/pages/sales-intelligence/types";
import { createAsyncAction, createAction } from "typesafe-actions";
import type { IntegrationStatusResponse } from "../../../components/types";
import type { ExportNotification, ExportSetting, ExportSettingWithType, SalesforceExportSettings } from "../../type";

export const fetchSFExportSettingsTableAsync = createAsyncAction(
    "@@si/management/salesforce/manage-export/FETCH_SF_EXPORT_SETTINGS_START",
    "@@si/management/salesforce/manage-export/FETCH_SF_EXPORT_SETTINGS_SUCCESS",
    "@@si/management/salesforce/manage-export/FETCH_SF_EXPORT_SETTINGS_FAILURE",
)<void, ExportSettingWithType, FetchError>();

export const fetchSfExportSettingsAsync = createAsyncAction(
    "@@si/salesforce-export/FETCH_SF_EXPORT_SETTINGS_START",
    "@@si/salesforce-export/FETCH_SF_EXPORT_SETTINGS_SUCCESS",
    "@@si/salesforce-export/FETCH_SF_EXPORT_SETTINGS_FAILURE",
)<void, SalesforceExportSettings, FetchError>();

export const saveSFExportSettingsAsync = createAsyncAction(
    "@@si/management/salesforce/manage-export/SAVE_SF_EXPORT_SETTINGS_START",
    "@@si/management/salesforce/manage-export/SAVE_SF_EXPORT_SETTINGS_SUCCESS",
    "@@si/management/salesforce/manage-export/SAVE_SF_EXPORT_SETTINGS_FAILURE",
)<void, ExportSettingWithType, FetchError>();

export const addNewSettingsExport = createAction(
    "@@si/management/salesforce/manage-export/ADD_NEW_EXPORT_SETTINGS",
)<ExportSettingWithType>();

export const updateSfSettingsExport = createAction(
    "@@si/management/salesforce/manage-export/UPDATE_EXPORT_SETTINGS",
)<ExportSettingWithType>();

export const deleteSettingExport = createAction(
    "@@si/management/salesforce/manage-export/DELETE_EXPORT_SETTING",
)<ExportSettingWithType>();

export const revertSettingsExport = createAction(
    "@@si/management/salesforce/manage-export/REVERT_EXPORT_SETTING",
)<ExportSettingWithType>();

export const setSfEditableField = createAction("@@si/management/salesforce/manage-export/SET_EDITABLE_FIELD")<
    ExportSetting | undefined
>();

export const setSfDeletableField = createAction("@@si/management/salesforce/manage-export/SET_DELETABLE_FIELD")<
    ExportSetting | undefined
>();

export const setSelectedSalesForceFields = createAction(
    "@@si/management/salesforce/manage-export/SET_SELECTED_SF_FIELD",
)<Record<string, boolean>>();

export const exportDomainsToSFAsync = createAsyncAction(
    "@@si/management/salesforce/manage-export/EXPORT_DOMAINS_SALES_FORCE_START",
    "@@si/management/salesforce/manage-export/EXPORT_DOMAINS_SALES_FORCE_SUCCESS",
    "@@si/management/salesforce/manage-export/EXPORT_DOMAINS_SALES_FORCE_FAILURE",
)<void, void, FetchError>();

export const showModalDisabledExportSF = createAction(
    "@@si/management/salesforce/manage-export/SHOW_MODAL_DISABLED_EXPORT_SF",
)<boolean>();

export const setSfNotification = createAction(
    "@@si/management/salesforce/manage-export/SET_NOTIFICATION",
)<null | ExportNotification>();

export const putAccountsToggleAsync = createAsyncAction(
    "@@si/management/salesforce/manage-integrations/PUT_ACCOUNTS_STATUS_START",
    "@@si/management/salesforce/manage-integrations/PUT_ACCOUNTS_STATUS_SUCCESS",
    "@@si/management/salesforce/manage-integrations/PUT_ACCOUNTS_STATUS_FAILURE",
)<void, IntegrationStatusResponse, FetchError>();

export const putLeadsToggleAsync = createAsyncAction(
    "@@si/management/salesforce/manage-integrations/PUT_LEADS_TOGGLE_START",
    "@@si/management/salesforce/manage-integrations/PUT_LEADS_TOGGLE_SUCCESS",
    "@@si/management/salesforce/manage-integrations/PUT_LEADS_TOGGLE_FAILURE",
)<void, IntegrationStatusResponse, FetchError>();

export const putCompanyAsLeadsToggleAsync = createAsyncAction(
    "@@si/management/salesforce/manage-integrations/PUT_COMPANY_AS_LEADS_TOGGLE_START",
    "@@si/management/salesforce/manage-integrations/PUT_COMPANY_AS_LEADS_TOGGLE_SUCCESS",
    "@@si/management/salesforce/manage-integrations/PUT_COMPANY_AS_LEADS_TOGGLE_FAILURE",
)<void, IntegrationStatusResponse, FetchError>();

export const putContactsToggleAsync = createAsyncAction(
    "@@si/management/salesforce/manage-integrations/PUT_CONTACTS_TOGGLE_START",
    "@@si/management/salesforce/manage-integrations/PUT_CONTACTS_TOGGLE_SUCCESS",
    "@@si/management/salesforce/manage-integrations/PUT_CONTACTS_TOGGLE_FAILURE",
)<void, IntegrationStatusResponse, FetchError>();

export const saveSfAllSettingsError = createAction(
    "@@si/management/salesforce/manage-export/SAVE_ALL_SETTINGS_ERROR",
)<string>();
